import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Alert, Button, Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Heading } from '@lomarengas/design-system';
import Select from 'react-select';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import {
  BookingType,
  bookingTypeTranslations,
} from '../Constants/BookingTypeEnum';

import {
  addAddOnToBookingContainerAsync,
  AddAddOnToBookingContainerItem,
  BookingContainer,
  BookingContainerUpdateItem,
  BookingDetailsData,
  BookingDetailsNoteItem,
  BookingDetailsOrderItem,
  confirmBookingAsync,
  CreateBookingNote,
  getBookingContainerDetailsAsync,
  getSelectableAddOnsAsync,
  removeFromBookingContainerAsync,
  RemoveFromBookingContainerItem,
  saveOwnerOwnBookingAsync,
  setWebShopCustomerState,
  TravelAgencyAccountData,
  TravelAgencyData,
  updateBookingContainerAsync,
  UpdateBookingToPreliminary,
  UpdateBookingToPreliminaryAsync,
  WebShopCustomerItem,
} from '../bookingsSlice';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { BillingLocales } from '../Constants/BillingLocales';
import {
  AccountDetailsFromDb,
  getAcountDetailsFromDbAsync,
} from '../../Users/identityUsersSlice';
import { addStatusToast, InputText, Loader } from '../../../common/components';
import { OwnerOwnBooking, OwnerOwnBookingNote } from '../OwnerOwnInterfaces';
import {
  getCountriesAsync,
  selectCountryItems,
} from '../../countries/countriesSlice';
import { useLocale } from '../../../locales/useLocale';
import { LOCALES } from '../../../common/constants';

export interface BooleanProps {
  showNewBookingModal;
  setShowNewBookingModal;
  editedBooking: BookingDetailsData;
  setEditedBooking;
  setBookingContainer;
  setBasketContainer;
  webshopCustomer;
}

export interface SelectableAddOnFilter {
  accommodationId: string;
  units: number;
  adults: number;
  childs: number;
  includeNonVisible: boolean;
}
/*
export interface TravelAgencyFinalClient {
  firstName: string;
  lastName: string;
  company: string;
  streetAddress: string;
  zipCode: string;
  city: string;
  country: string;
}
 */
const createEmptyTravelAgencyData = (): TravelAgencyAccountData => ({
  finalClientFirstName: '',
  finalClientLastName: '',
  finalClientCompany: '',
  finalClientStreetAddress: '',
  finalClientZipCode: '',
  finalClientCity: '',
  finalClientCountry: '',
  finalClientEmail: '',
  finalClientPhone: '',
  travelAgencyEmail: '',
  travelAgencyPhone: '',
});
export const NewTravelAgencyBookingModal: React.FC<BooleanProps> = ({
  showNewBookingModal,
  setShowNewBookingModal,
  editedBooking,
  setEditedBooking,
  setBookingContainer,
  setBasketContainer,
  webshopCustomer,
  ...props
}) => {
  const { t } = useTranslation(['common', 'travelAgencyBookingModal']);
  const { currentLocale } = useLocale();
  const textAreaRefs = useRef([]);
  const ownertextAreaRefs = useRef([]);
  const officertextAreaRefs = useRef([]);

  const history = useNavigate();
  const currentLanguage = currentLocale === LOCALES.Fi ? 'fi' : 'en';
  const dispatch = useAppDispatch();
  const countries = useAppSelector(selectCountryItems);
  const selectableAddOns = useAppSelector(
    state => state.bookings.selectableAddOns,
  );
  const initFetch = useCallback(() => {
    dispatch(
      getCountriesAsync({
        PageNumber: 1,
        PageSize: 100000,
        searchString: '',
        culture: currentLocale,
      }),
    );
  }, [dispatch]);
  /*
  const [travelAgencyFinalClient, setTravelAgencyFinalClient] =
    useState<TravelAgencyData>(createEmptyTravelAgencyFinalClient());
   */
  const [editedBookingLocal, setEditedBookingLocal] =
    useState<BookingDetailsData>(editedBooking);
  const [editedCustomerBookingNotes, setEditedCustomerBookingNotes] = useState<
    BookingDetailsNoteItem[]
  >(
    editedBookingLocal !== null &&
      editedBookingLocal !== undefined &&
      editedBookingLocal.customerBookingNotes !== null &&
      editedBookingLocal.customerBookingNotes !== undefined
      ? editedBookingLocal.customerBookingNotes
      : [],
  );

  const [editedOwnerBookingNotes, setEditedOwnerBookingNotes] = useState<
    BookingDetailsNoteItem[]
  >(
    editedBookingLocal !== null &&
      editedBookingLocal !== undefined &&
      editedBookingLocal.ownerBookingNotes !== null &&
      editedBookingLocal.ownerBookingNotes !== undefined
      ? editedBookingLocal.ownerBookingNotes
      : [],
  );
  const [editedOfficerBookingNotes, setEditedOfficerBookingNotes] = useState<
    BookingDetailsNoteItem[]
  >(
    editedBookingLocal !== null &&
      editedBookingLocal !== undefined &&
      editedBookingLocal.officerBookingNotes !== null &&
      editedBookingLocal.officerBookingNotes !== undefined
      ? editedBookingLocal.officerBookingNotes
      : [],
  );
  const [linenChecked, setLinenChecked] = useState(false);
  const [showLoader, setshowLoader] = useState<boolean>(false);
  const [cleaningChecked, setCleaningChecked] = useState(false);
  const [ownerOwnBookingType, setOwnerOwnBookingType] = useState('OwnerOwn');

  const [editedSelectableAddOns, seteditedSelectableAddOns] =
    useState<BookingDetailsOrderItem[]>(selectableAddOns);

  const [makingOwnerBooking, setMakingOwnerBooking] = useState<boolean>(false);

  const [selectedPayer, setSelectedPayer] =
    useState<AccountDetailsFromDb>(null);
  const initialBookingContainer: BookingContainer = {
    id: '',
    bookingContainerStatus: 0,
    bookingResponses: [],
    advancePaid: false,
    acceptMarketing: false,
    acceptCancelInsuranceTerms: false,
    acceptBookingTerms: false,
    siteId: '',
    adults: 0,
    childs: 0,
    containerTotal: 0,
    containerTravelTotal: 0,
  };
  function handleCloseBooking() {
    setShowNewBookingModal(false);
  }

  function handleCloseBookingOwner() {
    setShowNewBookingModal(false);
  }
  const countryOptions = countries.map(country => {
    return { value: country.id, label: country.name };
  });
  function updateBookingContainerWithData(newBooking, value) {
    if (editedBookingLocal === null) {
      return;
    }
    const container = {
      bookingContainerId: editedBookingLocal.bookingContainerId ?? '',
      bookingContainerStatus: 0,
      bookings: [newBooking],
      acceptBookingTerms: false,
      acceptCancelInsuranceTerms: false,
      acceptMarketing: false,
    } as BookingContainerUpdateItem;
    if (editedBookingLocal !== null) {
      setshowLoader(true);
      dispatch(updateBookingContainerAsync(container))
        .then(res => {
          if (res.payload.isSuccess === true) {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              const tempBookingTypeData2 = {
                ...findItem[0],
                bookingType: value,
              };
              setEditedBookingLocal(tempBookingTypeData2);
            }
          }
        })
        .finally(() => {
          setshowLoader(false);
        });
    }
  }
  function updateBookingContainer(
    incontainer: BookingDetailsData = null,
    finalSave: boolean = false,
  ) {
    if (editedBookingLocal === null) {
      return;
    }
    let localedited = editedBookingLocal;
    if (incontainer && incontainer !== null) {
      localedited = { ...incontainer };
    }
    const container = {
      bookingContainerId: editedBooking.bookingContainerId ?? '',
      bookingContainerStatus: 0,
      bookings: [localedited],
      acceptBookingTerms: false,
      acceptCancelInsuranceTerms: false,
      acceptMarketing: false,
      finalSave,
    } as BookingContainerUpdateItem;
    if (editedBooking !== null) {
      setshowLoader(true);
      dispatch(updateBookingContainerAsync(container))
        .then(res => {
          if (res.payload.isSuccess === true) {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
            }
          } else {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
            }
            dispatch(
              addStatusToast({
                Message:
                  t(
                    `travelAgencyBookingModal:validation:errors.${
                      res.payload.result.errors[0]
                    }`,
                  ) ?? t('travelAgencyBookingModal:validation:errors.Virhe'),
                IsFailed: true,
                Title: t('travelAgencyBookingModal:validation:errors.Virhe'),
              }),
            );
          }
        })
        .finally(() => {
          setshowLoader(false);
        });
    }
  }
  function updateBookingContainerAndClose() {
    if (editedBookingLocal === null) {
      return;
    }
    const container = {
      bookingContainerId: editedBooking.bookingContainerId ?? '',
      bookingContainerStatus: 0,
      bookings: [editedBookingLocal],
      acceptBookingTerms: false,
      acceptCancelInsuranceTerms: false,
      acceptMarketing: false,
    } as BookingContainerUpdateItem;
    if (editedBooking !== null) {
      setshowLoader(true);
      dispatch(updateBookingContainerAsync(container))
        .then(res => {
          if (res.payload.isSuccess === true) {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
              dispatch(setBasketContainer(initialBookingContainer));
              setShowNewBookingModal(false);
              history(`/bookings/${findItem[0].id}`);
            }
          } else {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(setBookingContainer(res.payload.result));
            }
            dispatch(
              addStatusToast({
                Message:
                  t(
                    `travelAgencyBookingModal:validation:errors.${
                      res.payload.result.errors[0]
                    }`,
                  ) ?? t('travelAgencyBookingModal:validation:errors.Virhe'),
                IsFailed: true,
                Title: t('travelAgencyBookingModal:validation:errors.Virhe'),
              }),
            );
          }
        })
        .finally(() => {
          setshowLoader(false);
        });
    } else {
      setShowNewBookingModal(false);
    }
  }
  const saveOwnerOwnBooking = () => {
    const ownerOwnBooking = {
      originalBookingId: editedBooking.id ?? '',
      ownerId: '00000000-0000-0000-0000-000000000000',
      AccommodationId: editedBookingLocal.bookingOrderItems[0].accommodationId,
      ArrivalDateTime: editedBookingLocal.bookingOrderItems[0].arrivalDateTime,
      DepartureDateTime: editedBooking.bookingOrderItems[0].departureDateTime,
      OwnerBookingNote: {
        NoteText: '',
      } as OwnerOwnBookingNote,
      Adults: 0,
      Childs: 0,
      BookingType: '',
    } as OwnerOwnBooking;
    // TODO: Handle arrival and departure time
    ownerOwnBooking.AccommodationId =
      editedBookingLocal.bookingOrderItems[0].accommodationId;
    ownerOwnBooking.ArrivalDateTime =
      editedBookingLocal.bookingOrderItems[0].startDateTime;
    ownerOwnBooking.DepartureDateTime =
      editedBookingLocal.bookingOrderItems[0].endDateTime;
    const numberOfPeopleInBooking =
      editedBookingLocal.bookingOrderItems[0].amountOfAdults +
      editedBookingLocal.bookingOrderItems[0].amountOfChildren;
    let notetext = '';
    if (linenChecked) {
      notetext += `${t('travelAgencyBookingModal:includes.linens', {
        count: numberOfPeopleInBooking,
      })}\n`;
    }
    if (cleaningChecked) {
      notetext += `${t('travelAgencyBookingModal:includes.finalCleaning')}\n`;
    }
    ownerOwnBooking.OwnerBookingNote = {
      NoteText: notetext,
    } as OwnerOwnBookingNote;
    ownerOwnBooking.Adults = editedBooking.bookingOrderItems[0].amountOfAdults;
    ownerOwnBooking.Childs =
      editedBookingLocal.bookingOrderItems[0].amountOfChildren;
    ownerOwnBooking.BookingType = ownerOwnBookingType;
    // callParentInitFetch();
    // handleModalClose();
    setshowLoader(true);
    dispatch(saveOwnerOwnBookingAsync(ownerOwnBooking))
      .then(res => {
        if (res.meta.requestStatus === 'fulfilled') {
          setEditedBooking(res.payload);
          setEditedBookingLocal(res.payload);
          dispatch(getBookingContainerDetailsAsync(res.payload.id));
          dispatch(
            addStatusToast({
              Message: `Omistajan oma varaus tallennettu!`,
            }),
          );
          dispatch(setBasketContainer(initialBookingContainer)).then(() => {
            history(`/bookings/${res.payload.id}`, {
              state: {
                webshopCustomer,
              },
            });
            handleCloseBookingOwner();
          });
        }
      })
      .finally(() => {
        setshowLoader(false);
      });
  };
  function localSetEditedBooking(booking) {
    setEditedBookingLocal(booking);
  }
  function makeOwnerBooking() {
    if (editedBookingLocal !== null) {
      const newbookingOrderItems = [] as BookingDetailsOrderItem[];
      editedBookingLocal.bookingOrderItems.map(item => {
        if (item.orderItemType === 0) {
          item = {
            ...item,
            pricesResponse: {
              ...item.pricesResponse,
              netPrice: 0,
              grossPrice: 0,
              grossPriceVat: 0,
              discountP: 0,
              travelAgencyComissionP: 0,
            },
            purchasePricesResponse: {
              ...item.purchasePricesResponse,
              sitePurchasePrice: 0,
              sitePurchasePriceVat: 0,
              ownerPurchasePrice: 0,
              ownerPurchasePriceVat: 0,
            },
          };
          return newbookingOrderItems.push(item);
        }
        return null;
      });

      // Create a new copy of editedBooking and update bookingOrderItems
      const newEditedBooking = {
        ...editedBookingLocal,
        bookingOrderItems: newbookingOrderItems,
        bookingType: 5,
      };
      localSetEditedBooking(newEditedBooking);
      setMakingOwnerBooking(true);
    }
  }

  function confirmBooking() {
    if (editedBookingLocal !== null) {
      setshowLoader(true);
      dispatch(setWebShopCustomerState(null));
      dispatch(confirmBookingAsync(editedBookingLocal))
        .then(res => {
          if (res.payload.isSuccess !== true) {
            if (res.payload.isSuccess === false) {
              if (res.payload.message != null) {
                dispatch(
                  addStatusToast({
                    Message: res.payload.message,
                    IsFailed: true,
                    Title: t('common:texts.error'),
                  }),
                );
              }
              if (
                res.payload.result != null &&
                res.payload.result.errors != null &&
                res.payload.result.errors.length > 0
              ) {
                res.payload.result.errors.map(error => {
                  return dispatch(
                    addStatusToast({
                      Message: error,
                      IsFailed: true,
                      Title: t('common:texts.error'),
                      DelayMs: 10000,
                      IsAutohide: false,
                    }),
                  );
                });
              }
            } else if (
              res.payload.errorCode !== null &&
              res.payload.Message !== null
            ) {
              // dispatch(
              //   addStatusToast({
              //     Message: res.payload.Message,
              //     IsFailed: true,
              //     Title: 'Virhe',
              //   }),
              // );
            }
          } else {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(getBookingContainerDetailsAsync(findItem[0].id));
              dispatch(setBasketContainer(initialBookingContainer)).then(() => {
                const navigationPath = `/bookings/${findItem[0].id}`;
                history(navigationPath, {
                  state: {
                    id: res.payload.result.id,
                    from: window.location.pathname,
                  },
                });
                handleCloseBooking();
              });
            }
          }
        })
        .catch(err => {
          dispatch(
            addStatusToast({
              Message: t(
                'travelAgencyBookingModal:validation:errors.confirmationError',
              ),
              IsFailed: true,
              Title: t('common:texts.error'),
            }),
          );
        })
        .finally(() => {
          setshowLoader(false);
        });
    }
  }
  useEffect(() => {
    initFetch();
  }, [initFetch]);

  useEffect(() => {
    if (
      selectableAddOns !== null &&
      selectableAddOns.length > 0 &&
      editedBooking != null
    ) {
      const accommodationItem = editedBooking.bookingOrderItems?.find(
        i => i.orderItemType === 0,
      );
      if (accommodationItem) {
        const updatedSelectableAddOns = selectableAddOns.map(addOn => ({
          ...addOn,
          amountOfAdults: accommodationItem.amountOfAdults,
        }));
        seteditedSelectableAddOns(updatedSelectableAddOns);
      }
    }
  }, [selectableAddOns, editedBooking]);

  useEffect(() => {
    if (editedBookingLocal) {
      if (editedBookingLocal.customerBookingNotes) {
        setEditedCustomerBookingNotes(editedBookingLocal.customerBookingNotes);
      }
      if (editedBookingLocal.ownerBookingNotes) {
        setEditedOwnerBookingNotes(editedBookingLocal.ownerBookingNotes);
      }
      if (editedBookingLocal.officerBookingNotes) {
        setEditedOfficerBookingNotes(editedBookingLocal.officerBookingNotes);
      }
    }
  }, [editedBookingLocal]);
  useEffect(() => {
    if (editedBooking) {
      const item = editedBooking.bookingOrderItems?.find(
        i => i.orderItemType === 0,
      );
      if (item) {
        const filter = {
          accommodationId: item.accommodationId,
          units: item.units,
          adults: item.amountOfAdults,
          childs: item.amountOfChildren,
          includeNonVisible: true,
        } as SelectableAddOnFilter;
        dispatch(getSelectableAddOnsAsync(filter));
      }
      if (
        editedBooking.payerId !== null &&
        editedBooking.payerId !== undefined &&
        editedBooking.payerId !== 'undefined' &&
        editedBooking.payerId !== ''
      ) {
        dispatch(getAcountDetailsFromDbAsync(editedBooking.payerId)).then(
          res => {
            setSelectedPayer(res.payload);
          },
        );
      }
      setEditedBookingLocal(editedBooking);
    }
  }, [editedBooking, dispatch]);

  useEffect(() => {
    if (makingOwnerBooking) {
      makeOwnerBooking();
    }
  }, [makingOwnerBooking]);

  useEffect(() => {
    if (editedBookingLocal?.bookingType === 5) {
      setMakingOwnerBooking(true);
    }
  }, [editedBookingLocal]);
  function getGlobalEndDate() {
    if (
      editedBooking != null &&
      editedBooking.bookingOrderItems != null &&
      editedBooking.bookingOrderItems.length > 0
    ) {
      const item = editedBooking.bookingOrderItems.filter(
        i => i.orderItemType === 0,
      );
      if (item != null && item.length > 0) {
        return item[0].endDateTime;
      }
    }
    return '';
  }

  function getGlobalStartDate() {
    if (
      editedBooking != null &&
      editedBooking.bookingOrderItems != null &&
      editedBooking.bookingOrderItems.length > 0
    ) {
      const item = editedBooking.bookingOrderItems.filter(
        i => i.orderItemType === 0,
      );
      if (item != null && item.length > 0) {
        return item[0].startDateTime;
      }
    }
    return '';
  }
  function selectPayer() {
    if (
      webshopCustomer !== null &&
      webshopCustomer !== undefined &&
      webshopCustomer.lastName != null &&
      (editedBooking.payerId === null || editedBooking.payerId === undefined)
    ) {
      const init = {
        payer: 'pick',
        bookingId: editedBookingLocal.id,
        bookingType: editedBookingLocal.bookingType,
        bookingLocale: editedBookingLocal.invoicingLanguageLocale,
        webshopCustomer,
      };
      history(`/customers/search`, { state: init });
    } else {
      const webshopCustomerCommand = {
        firstName: editedBooking.payerFirstName,
        lastName: editedBooking.payerLastName,
      } as WebShopCustomerItem;
      const init = {
        payer: 'pick',
        bookingId: editedBookingLocal.id,
        bookingType: editedBookingLocal.bookingType,
        bookingLocale: editedBookingLocal.invoicingLanguageLocale,
        webshopCustomer: webshopCustomerCommand,
      };
      history(`/customers/search`, {
        state: init,
      });
    }
  }
  const handleAddCustomerBookingNote = event => {
    const newbookingNote = {
      id: uuidv4(),
      noteText: '',
    } as CreateBookingNote;
    const newBookingNoteItems = [...editedCustomerBookingNotes, newbookingNote];
    setEditedCustomerBookingNotes(newBookingNoteItems);
  };
  // const handleAddOwnerBookingNote = event => {
  //   const newbookingNote = {
  //     noteText: '',
  //   } as CreateBookingNote;
  //   const newBookingNoteItems = [...editedOwnerBookingNotes, newbookingNote];
  //   setEditedOwnerBookingNotes(newBookingNoteItems);
  // };
  // const handleAddOfficerBookingNote = event => {
  //   const newbookingNote = {
  //     noteText: '',
  //   } as CreateBookingNote;
  //   const newBookingNoteItems = [...editedOfficerBookingNotes, newbookingNote];
  //   setEditedOfficerBookingNotes(newBookingNoteItems);
  // };
  const handleAddToContainer = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const addedItem = editedSelectableAddOns[index];

    // Update the state
    const addAddOnData = {
      bookingId: editedBookingLocal.id,
      accommodationAddOnId: addedItem.id,
      adults: addedItem.amountOfAdults,
      childs: addedItem.amountOfChildren,
      units: addedItem.units,
      grossPrice: addedItem.pricesResponse.grossPrice,
      sitePurchasePrice: addedItem.purchasePricesResponse.sitePurchasePrice,
      arrivalDateTime: getGlobalStartDate(),
      departureDateTime: getGlobalEndDate(),
      bookingContainerId: editedBooking.bookingContainerId,
    } as AddAddOnToBookingContainerItem;
    dispatch(addAddOnToBookingContainerAsync(addAddOnData)).then(res => {
      if (res.payload.isSuccess === true) {
        const findItem = res.payload.result.bookingResponses.filter(
          i => i.id === editedBooking.id,
        );
        if (findItem != null && findItem.length > 0) {
          const newBookingOrderItems = [
            ...editedBookingLocal.bookingOrderItems,
            addedItem,
          ];

          // Create a new copy of editedBooking and update bookingOrderItems
          const newEditedBooking = {
            ...editedBookingLocal,
            bookingOrderItems: newBookingOrderItems,
            bookingType: editedBookingLocal.bookingType,
          };
          localSetEditedBooking(newEditedBooking);
          const newEditedBookingType = {
            ...editedBookingLocal,
            bookingType: editedBookingLocal.bookingType,
          };
          setEditedBookingLocal(newEditedBookingType);
          setEditedBooking(newEditedBookingType);
          dispatch(setBookingContainer(res.payload.result));
        }
      }
    });
  };

  function handleSaveBooking() {
    if (editedBookingLocal.travelAgencyData == null) {
      dispatch(
        addStatusToast({
          Message: t(
            'travelAgencyBookingModal:validation:errors.fillEndCustomerInfo',
          ),
          IsFailed: true,
          Title: t('common:texts.saveFailed'),
        }),
      );
      return;
    }
    if (
      editedBookingLocal.travelAgencyData.finalClientFirstName == null ||
      editedBookingLocal.travelAgencyData.finalClientFirstName.length === 0
    ) {
      dispatch(
        addStatusToast({
          Message: t(
            'travelAgencyBookingModal:validation:errors.firstNameRequired',
          ),
          IsFailed: true,
          Title: t('common:texts.saveFailed'),
        }),
      );
      return;
    }
    if (
      editedBookingLocal.travelAgencyData.finalClientLastName == null ||
      editedBookingLocal.travelAgencyData.finalClientLastName.length === 0
    ) {
      dispatch(
        addStatusToast({
          Message: t(
            'travelAgencyBookingModal:validation:errors.lastNameRequired',
          ),
          IsFailed: true,
          Title: t('common:texts.saveFailed'),
        }),
      );
      return;
    }

    if (
      editedBookingLocal.travelAgencyData.finalClientCountry == null ||
      editedBookingLocal.travelAgencyData.finalClientCountry.length === 0
    ) {
      dispatch(
        addStatusToast({
          Message: t(
            'travelAgencyBookingModal:validation:errors.countryRequired',
          ),
          IsFailed: true,
          Title: t('common:texts.saveFailed'),
        }),
      );
      return;
    }
    if (
      editedBookingLocal.travelAgencyData.finalClientPhone == null ||
      editedBookingLocal.travelAgencyData.finalClientPhone.length === 0
    ) {
      dispatch(
        addStatusToast({
          Message: t(
            'travelAgencyBookingModal:validation:errors.phoneRequired',
          ),
          IsFailed: true,
          Title: t('common:texts.saveFailed'),
        }),
      );
      return;
    }
    // saveNewBooking(editedBooking);s
    history(`/bookings/${editedBooking.id}`, {
      state: {
        webshopCustomer,
      },
    });
    // Clear basket because booking is finished from travel agencys point of view
    dispatch(setBasketContainer(initialBookingContainer));
    setShowNewBookingModal(false);
    updateBookingContainer(null, true);
  }

  function handleUpdateToPleriminaryBooking() {
    const container = {
      bookingId: editedBooking.id,
    } as UpdateBookingToPreliminary;
    if (editedBookingLocal !== null) {
      dispatch(UpdateBookingToPreliminaryAsync(container)).then(res => {
        if (res.payload.isSuccess === true) {
          const findItem = res.payload.result.bookingResponses.filter(
            i => i.id === editedBooking.id,
          );
          if (findItem != null && findItem.length > 0) {
            setEditedBookingLocal(findItem[0]);
            setEditedBooking(findItem[0]);
            dispatch(setBookingContainer(res.payload.result));
          }
        }
      });
    }
  }

  const handlGrosPriceChange = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      pricesResponse: {
        ...newBookingOrderItems[index].pricesResponse,
        netPrice: Number(value),
      },
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  const handleSitePurchsePriceChange = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      purchasePricesResponse: {
        ...newBookingOrderItems[index].purchasePricesResponse,
        sitePurchasePrice: Number(value),
      },
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  const handlTravelPChange = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      pricesResponse: {
        ...newBookingOrderItems[index].pricesResponse,
        travelAgencyComissionP: Number(value),
      },
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  const handlAdvanceBillPriceChange = event => {
    const { target } = event;
    const { value } = target;
    // Create a new copy of editedBooking and update advanceBillPrice
    if (Number(value) < 0) {
      const newEditedBooking = {
        ...editedBookingLocal,
        advanceBillPrice: 0,
      };

      // Update the state
      localSetEditedBooking(newEditedBooking);
    } else {
      const newEditedBooking = {
        ...editedBookingLocal,
        advanceBillPrice: Number(value),
      };

      // Update the state
      localSetEditedBooking(newEditedBooking);
    }
  };

  const handlDiscountChange = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      pricesResponse: {
        ...newBookingOrderItems[index].pricesResponse,
        discountP: Number(value),
      },
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  function enumToArray(enumObj: unknown) {
    const keys = Object.keys(enumObj);
    return keys
      .filter(key => Number.isInteger(Number.parseInt(enumObj[key], 10)))
      .map(key => ({ name: key, value: Number.parseInt(enumObj[key], 10) }));
  }
  function getBookingTypeTranslation(
    bookingType: BookingType,
    locale: 'en' | 'fi',
  ): string {
    return (
      bookingTypeTranslations[locale][bookingType] || t('common:texts.unknown')
    );
  }

  const bookingTypeItems = enumToArray(BookingType).map(item => {
    return {
      value: item.value,
      label: getBookingTypeTranslation(item.value, currentLanguage),
    };
  });

  const getAllowedBookingTypes = () => {
    if (editedBooking === null || editedBooking === undefined) {
      return bookingTypeItems;
    }
    if (editedBooking.bookingType === 0) {
      return bookingTypeItems.filter(
        bt =>
          bt.value === 1 ||
          bt.value === 0 ||
          bt.value === 15 ||
          bt.value === 5 ||
          bt.value === 6,
      );
    }
    if (editedBooking.bookingType === 1) {
      return bookingTypeItems.filter(bt => bt.value === 1 || bt.value === 1);
    }
    if (editedBooking.bookingType === 2) {
      return bookingTypeItems.filter(bt => bt.value === 1 || bt.value === 2);
    }
    if (editedBooking.bookingType === 3) {
      return bookingTypeItems.filter(bt => bt.value === 3);
    }
    if (editedBooking.bookingType === 9) {
      return bookingTypeItems.filter(bt => bt.value === 10 || bt.value === 9);
    }
    if (editedBooking.bookingType === 10) {
      return bookingTypeItems.filter(bt => bt.value === 10 || bt.value === 9);
    }
    if (editedBooking.bookingType === 4) {
      return bookingTypeItems.filter(bt => bt.value === 4);
    }
    if (editedBooking.bookingType === 5) {
      return bookingTypeItems.filter(bt => bt.value === 5);
    }
    if (editedBooking.bookingType === 6) {
      return bookingTypeItems.filter(bt => bt.value === 6 || bt.value === 0);
    }
    if (editedBooking.bookingType === 7) {
      return bookingTypeItems.filter(bt => bt.value === 8 || bt.value === 7);
    }
    if (editedBooking.bookingType === 8) {
      return bookingTypeItems.filter(bt => bt.value === 8);
    }
    if (editedBooking.bookingType === 9) {
      return bookingTypeItems.filter(bt => bt.value === 10 || bt.value === 9);
    }
    if (editedBooking.bookingType === 13) {
      return bookingTypeItems.filter(bt => bt.value === 13);
    }
    if (editedBooking.bookingType === 14) {
      return bookingTypeItems.filter(bt => bt.value === 14);
    }
    if (editedBooking.bookingType === 15) {
      return bookingTypeItems.filter(bt => bt.value === 0 || bt.value === 15);
    }
    return bookingTypeItems;
  };
  const billingLocales = enumToArray(BillingLocales).map(item => {
    return { value: item.value, label: item.name };
  });
  const handlUnitsChange = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      units: Number(value),
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
    // update to db
    updateBookingContainer(newEditedBooking);
  };

  const handleCustomerCommentChange = event => {
    // Update the state
    const index = Number(event.target.name);
    const newNotes = editedCustomerBookingNotes.map((item, idx) => {
      if (index === idx) {
        return {
          ...item,
          noteText: event.target.value,
        };
      }
      return item;
    });
    setEditedCustomerBookingNotes(newNotes);

    const neweditedBooking = {
      ...editedBookingLocal,
      customerBookingNotes: newNotes,
    };
    setEditedBookingLocal(neweditedBooking);
  };
  const handlUnitsChangeSelectable = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedSelectableAddOns];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      units: Number(value),
    };

    // Update the state
    seteditedSelectableAddOns(newBookingOrderItems);
  };

  const handlAdultsChangeRow = event => {
    const { target } = event;
    const { value } = target;
    let newAmountOfAdults = Number(value);
    if (newAmountOfAdults < 1) {
      newAmountOfAdults = 1;
    }

    // Update the amountOfAdults for all bookingOrderItems
    const newBookingOrderItems = editedBookingLocal.bookingOrderItems.map(
      item => ({
        ...item,
        amountOfAdults: newAmountOfAdults,
      }),
    );
    const index = Number(target.name);
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      amountOfAdults: Number(value),
    };
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };
    setEditedBookingLocal(newEditedBooking);
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, indexx) => {
        return {
          ...item,
          amountOfAdults: Number(event.target.value),
        };
      }),
    );
    // Update the state
    localSetEditedBooking(newEditedBooking);
    // update to db
    updateBookingContainer(newEditedBooking);
  };
  const handlChildChangeRow = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    // const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];
    const newBookingOrderItems = editedBookingLocal.bookingOrderItems.map(
      item => ({
        ...item,
        amountOfChildren: value,
      }),
    );

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      amountOfChildren: Number(value),
    };
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };
    setEditedBookingLocal(newEditedBooking);
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, indexx) => {
        return {
          ...item,
          amountOfChildren: Number(event.target.value),
        };
      }),
    );
    // Update the state
    localSetEditedBooking(newEditedBooking);
    // update to db
    updateBookingContainer(newEditedBooking);
  };

  const handlAdultsChangeSelectable = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedSelectableAddOns];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      amountOfAdults: Number(value),
    };

    // Update the state
    seteditedSelectableAddOns(newBookingOrderItems);
  };

  const hanldleChildsChangeSelectable = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedSelectableAddOns];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      amountOfChildren: Number(value),
    };

    // Update the state
    seteditedSelectableAddOns(newBookingOrderItems);
  };

  const handlGrossPriceChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            pricesResponse: {
              ...item.pricesResponse,
              grossPrice: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };

  const handlPurchasePriceChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            purchasePricesResponse: {
              ...item.purchasePricesResponse,
              sitePurchasePrice: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };

  const handlDiscountChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            pricesResponse: {
              ...item.pricesResponse,
              discountP: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };

  const handlTravelCommissionPChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            pricesResponse: {
              ...item.pricesResponse,
              travelAgencyComissionP: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };
  const setRef = (el, index) => {
    textAreaRefs.current[index] = el;
  };
  const setOwnerRef = (el, index) => {
    ownertextAreaRefs.current[index] = el;
  };

  const setOfficerRef = (el, index) => {
    officertextAreaRefs.current[index] = el;
  };
  const generateItemKey = function (Index: number, Text: string) {
    return `${Index.toString()}-${encodeURI(Text.substring(0, 12))}`;
  };

  const handleSelectChangeBookingType = (selectedOption, name) => {
    if (selectedOption === null) {
      return;
    }
    if (selectedOption.value === 5) {
      setMakingOwnerBooking(true);
      makeOwnerBooking();
    } else if (selectedOption.value !== 5) {
      // updateBookingContainer();
      setMakingOwnerBooking(false);
      const tempBookingTypeData2 = {
        ...editedBooking,
        bookingType: selectedOption.value,
      };
      setEditedBookingLocal(tempBookingTypeData2);
      updateBookingContainerWithData(
        tempBookingTypeData2,
        selectedOption.value,
      );
    }
  };
  const selectableAddOnItems = editedSelectableAddOns.map((item, index) => (
    <tr key={item.id}>
      <td>
        {item.addOnNumber !== null && item.addOnNumber > 0
          ? item.addOnNumber
          : ''}{' '}
        {item.accommodationNumber !== undefined && item.accommodationNumber > 0
          ? `${item.accommodationNumber} : `
          : ''}
        {item.itemName !== undefined ? item.itemName : ''}
        {item.includedInPrice && (
          <div className="text-danger">
            {t(
              'travelAgencyBookingModal:sections:servicesInCart.includedInPrice',
            )}
          </div>
        )}
      </td>
      <td>
        {getGlobalStartDate() !== ''
          ? new Date(Date.parse(getGlobalStartDate())).toLocaleString('fi-FI', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
          : ''}{' '}
        -{' '}
        {getGlobalEndDate() !== ''
          ? new Date(Date.parse(getGlobalEndDate())).toLocaleString('fi-FI', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
          : ''}
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          disabled={item.amountPerQuantity !== true}
          name={index.toString()}
          value={item.units ?? ''}
          onChange={handlUnitsChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          disabled={item.amountPerGuest !== true}
          name={index.toString()}
          value={item.amountOfAdults ?? ''}
          onChange={handlAdultsChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          disabled={item.amountPerGuest !== true}
          name={index.toString()}
          value={item.amountOfChildren ?? ''}
          onChange={hanldleChildsChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          name={index.toString()}
          disabled
          value={item.pricesResponse.grossPrice ?? ''}
          onChange={handlGrossPriceChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Button
          size="sm"
          variant="outline-blue"
          name={index.toString()}
          onClick={handleAddToContainer}
        >
          {t('travelAgencyBookingModal:modal:buttons.addToBooking')}
        </Button>
      </td>
    </tr>
  ));
  const handleRemoveFromContainer = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const addedItem = editedBookingLocal.bookingOrderItems[index];

    // Update the state
    const removeData = {
      bookingId: editedBookingLocal.id,
      bookingContainerId: editedBooking.bookingContainerId,
      orderItemId: addedItem.id,
    } as RemoveFromBookingContainerItem;
    dispatch(removeFromBookingContainerAsync(removeData)).then(res => {
      if (res.payload.isSuccess === true) {
        const findItem = res.payload.result.bookingResponses.filter(
          i => i.id === editedBooking.id,
        );
        if (findItem != null && findItem.length > 0) {
          const newBookingOrderItems = [
            ...editedBookingLocal.bookingOrderItems,
            addedItem,
          ];

          // Create a new copy of editedBooking and update bookingOrderItems
          const newEditedBooking = {
            ...editedBookingLocal,
            bookingOrderItems: newBookingOrderItems,
            bookingType: editedBookingLocal.bookingType,
          };
          localSetEditedBooking(newEditedBooking);
          const newEditedBookingType = {
            ...editedBookingLocal,
            bookingType: editedBookingLocal.bookingType,
          };
          setEditedBookingLocal(newEditedBookingType);
          setEditedBooking(newEditedBookingType);
          dispatch(setBookingContainer(res.payload.result));
        }
      } else {
        dispatch(
          addStatusToast({
            Message: `${t(
              'travelAgencyBookingModal:validation:errors.deletionFailed',
            )}${res.payload.message}`,
            IsFailed: true,
            Title: t('common:texts.error'),
          }),
        );
      }
    });
  };
  const bookingOrderItems =
    editedBookingLocal?.bookingOrderItems != null ? (
      editedBookingLocal?.bookingOrderItems.map((item, index) => (
        <tr key={item.id}>
          <td>
            {item.addOnNumber !== null && item.addOnNumber > 0
              ? item.addOnNumber
              : ''}{' '}
            {item.accommodationNumber !== undefined &&
              item.accommodationNumber > 0 &&
              item.accommodationNumber}{' '}
            {item.itemName !== undefined ? item.itemName : ''}
            {item.includedInPrice && (
              <div style={{ color: 'blue' }}>
                {t(
                  'travelAgencyBookingModal:sections:servicesInCart.includedInPrice',
                )}
              </div>
            )}
          </td>
          <td>
            {item.startDateTime !== undefined
              ? new Date(Date.parse(item.startDateTime)).toLocaleString('fi-FI')
              : ''}{' '}
            -{' '}
            {item.endDateTime !== undefined
              ? new Date(Date.parse(item.endDateTime)).toLocaleString('fi-FI')
              : ''}
          </td>
          <td>{item.ownerAccountId != null && item.ownerName}</td>
          <td>
            <Form.Control
              size="sm"
              type="number"
              disabled
              name={index.toString()}
              value={item.units !== undefined ? item.units : ''}
              onChange={handlUnitsChange}
              className="px-8"
            />
          </td>
          <td>
            <Form.Control
              size="sm"
              type="number"
              name={index.toString()}
              disabled={
                item.orderItemType !== 0 ||
                (editedBookingLocal &&
                  (editedBookingLocal.advanceBilled === null ||
                    editedBookingLocal.advanceBilled === undefined ||
                    editedBookingLocal.advanceBilled === false) &&
                  editedBookingLocal.paymentAmount !== null &&
                  editedBookingLocal.paymentAmount !== undefined &&
                  editedBookingLocal.paymentAmount !== undefined &&
                  editedBookingLocal.paymentAmount > 0)
              }
              value={
                item.amountOfAdults !== undefined ? item.amountOfAdults : ''
              }
              onChange={handlAdultsChangeRow}
              className="px-8"
            />
          </td>
          <td>
            <Form.Control
              size="sm"
              type="number"
              name={index.toString()}
              disabled={
                item.orderItemType !== 0 ||
                (editedBookingLocal &&
                  (editedBookingLocal.advanceBilled === null ||
                    editedBookingLocal.advanceBilled === undefined ||
                    editedBookingLocal.advanceBilled === false) &&
                  editedBookingLocal.paymentAmount !== null &&
                  editedBookingLocal.paymentAmount !== undefined &&
                  editedBookingLocal.paymentAmount !== undefined &&
                  editedBookingLocal.paymentAmount > 0)
              }
              value={
                item.amountOfChildren !== undefined ? item.amountOfChildren : ''
              }
              onChange={handlChildChangeRow}
              className="px-8"
            />
          </td>
          <td>
            <Form.Control
              size="sm"
              type="number"
              disabled
              name={index.toString()}
              value={item.pricesResponse.grossPrice ?? ''}
              onChange={handlGrosPriceChange}
              className="px-8"
            />
          </td>
          {/* <td> */}
          {/*  <Form.Control */}
          {/*    size="sm" */}
          {/*    disabled */}
          {/*    type="number" */}
          {/*    name={index.toString()} */}
          {/*    value={item.pricesResponse.travelAgencyOnlyComission ?? ''} */}
          {/*    onChange={handlTravelPChange} */}
          {/*    className="px-8" */}
          {/*  /> */}
          {/* </td> */}
        </tr>
      ))
    ) : (
      <tr />
    );

  const handleTravelAgencySelectChangeCountry = e => {
    if (e !== null && e.value !== null) {
      setEditedBookingLocal(prev => {
        // Ensure travelAgencyData is initialized if undefined or null
        const baseTravelAgencyData =
          prev.travelAgencyData ?? createEmptyTravelAgencyData();

        // Create new object instead of mutating immutable Redux state
        const travelAgencyData = {
          ...baseTravelAgencyData,
          finalClientCountry: e.value,
        };

        // Return the updated state
        return {
          ...prev,
          travelAgencyData,
        };
      });
    }
  };
  const handleTravelAgencyClientInputChange = (
    fieldName: keyof TravelAgencyData,
    value: string,
  ) => {
    setEditedBookingLocal(prev => {
      // Ensure travelAgencyData is initialized if undefined or null
      const baseTravelAgencyData =
        prev.travelAgencyData ?? createEmptyTravelAgencyData();

      // Create new object instead of mutating immutable Redux state
      const travelAgencyData = {
        ...baseTravelAgencyData,
        [fieldName]: value,
      };

      // Return the updated state
      return {
        ...prev,
        travelAgencyData,
      };
    });
    // console.log('updated EditedBookingLocal, travelAgencyData');
    // console.log(editedBookingLocal);
  };

  return (
    <Modal
      show={showNewBookingModal}
      onHide={() => handleCloseBooking()}
      backdrop="static"
      fullscreen
      keyboard={false}
      size="xl"
    >
      <Modal.Header>
        <div>
          <Modal.Title>
            {t('travelAgencyBookingModal:modal:title.edit')}{' '}
            {editedBookingLocal !== null &&
            editedBookingLocal.bookingNumber === 0
              ? t('travelAgencyBookingModal:modal:title.unconfirmed')
              : editedBookingLocal?.bookingNumber}
          </Modal.Title>
          {editedBooking !== null && editedBooking.bookingType != null && (
            <div className="my-8">
              <span className="fw-bold small">
                {t('travelAgencyBookingModal:modal:title.bookingType')}
              </span>
              <br />
              {getBookingTypeTranslation(
                editedBooking.bookingType,
                currentLanguage,
              )}
            </div>
          )}
          {editedBooking !== null &&
            (editedBooking.bookingType === 0 ||
              editedBooking.bookingType === 6 ||
              editedBooking.bookingType === 3 ||
              editedBooking.bookingType === 9) && (
              <div>
                <h4>
                  {t('travelAgencyBookingModal:modal:title.newBookingType')}
                  :{' '}
                </h4>
                <Select
                  inputId="bookingType"
                  isDisabled
                  name="bookingType"
                  placeholder={t(
                    'travelAgencyBookingModal:modal:placeholders.selectBookingType',
                  )}
                  onChange={option =>
                    handleSelectChangeBookingType(option, 'bookingType')
                  }
                  options={getAllowedBookingTypes()}
                  value={bookingTypeItems.filter(
                    option =>
                      option.value ===
                      (editedBookingLocal !== undefined &&
                      editedBookingLocal !== null
                        ? editedBookingLocal.bookingType
                        : 0),
                  )}
                />
              </div>
            )}
          {editedBooking !== null &&
            editedBooking !== null &&
            editedBooking.bookingType === 15 && (
              <Alert variant="primary" className="mt-16">
                {t('travelAgencyBookingModal:modal:alerts.draftBooking')}
              </Alert>
            )}
        </div>
      </Modal.Header>
      <Modal.Body className="px-24 py-24 px-lg-40">
        <Loader IsLoading={showLoader} />
        <div className="text-end d-flex flex-column flex-sm-row gap-8 justify-content-end mb-16">
          {makingOwnerBooking === false && (
            <Button
              size="sm"
              variant="outline-blue"
              onClick={() => updateBookingContainer()}
            >
              {t('common:buttons.update')}
            </Button>
          )}
          {makingOwnerBooking === false &&
            editedBookingLocal !== null &&
            editedBookingLocal !== null &&
            editedBookingLocal.bookingType === 0 &&
            editedBookingLocal.payerId !== null &&
            editedBookingLocal.payerId !== undefined && (
              <Button
                size="sm"
                variant="primary"
                onClick={() => updateBookingContainerAndClose()}
              >
                {t('travelAgencyBookingModal:modal:buttons.confirmBooking', {
                  defaultValue: 'Vahvista varaus',
                })}
              </Button>
            )}
          {makingOwnerBooking === true &&
            editedBooking !== null &&
            editedBooking !== null &&
            editedBooking.bookingType !== 15 &&
            editedBooking.bookingType !== 5 && (
              <Button size="sm" variant="primary" onClick={saveOwnerOwnBooking}>
                {t(
                  'travelAgencyBookingModal:modal:buttons.confirmOwnerBooking',
                )}
              </Button>
            )}
          {editedBooking !== null &&
            editedBooking !== undefined &&
            editedBooking.bookingType === 15 && (
              <Button
                size="sm"
                variant="primary"
                onClick={() => handleUpdateToPleriminaryBooking()}
              >
                {t('travelAgencyBookingModal:modal:buttons.saveAsPreliminary')}
              </Button>
            )}
        </div>
        <Heading
          Level={4}
          Title={t('travelAgencyBookingModal:sections:servicesInCart.title')}
        />
        <div className="table-responsive-lg mb-48">
          <Table className="table-data table-wrap mt-16 mb-32">
            <thead>
              <tr key="header">
                <th key="header-1">
                  {t(
                    'travelAgencyBookingModal:sections:servicesInCart:table.service',
                  )}
                </th>
                <th key="header-3">
                  {t(
                    'travelAgencyBookingModal:sections:servicesInCart:table.duration',
                  )}
                </th>
                <th key="header-2">
                  {t(
                    'travelAgencyBookingModal:sections:servicesInCart:table.ownerCaretaker',
                  )}
                </th>
                <th key="header-4">
                  {t(
                    'travelAgencyBookingModal:sections:servicesInCart:table.quantity',
                  )}
                </th>
                <th key={Math.random()} style={{ width: '100px' }}>
                  {t(
                    'travelAgencyBookingModal:sections:servicesInCart:table.adults',
                  )}
                </th>
                <th key={Math.random()}>
                  {t(
                    'travelAgencyBookingModal:sections:servicesInCart:table.children',
                  )}
                </th>
                <th key="header-5">
                  {t(
                    'travelAgencyBookingModal:sections:servicesInCart:table.price',
                  )}
                </th>
                {/* <th key="header-9"> */}
                {/*  {t( */}
                {/*    'travelAgencyBookingModal:sections:servicesInCart:table.commission', */}
                {/*  )} */}
                {/* </th> */}
              </tr>
            </thead>
            <tbody>{bookingOrderItems}</tbody>
          </Table>

          {editedBooking && (
            <div style={{ textAlign: 'right' }} className="fw-bold large ">
              <span style={{ textAlign: 'right' }}>
                {t(
                  'travelAgencyBookingModal:sections:servicesInCart.totalPrice',
                )}
                :
              </span>{' '}
              {editedBooking.travelAgencyNetPrice.toFixed(2)}€
            </div>
          )}
        </div>
        <Col>
          <Heading
            Level={4}
            Title={t('travelAgencyBookingModal:sections:endCustomer.title')}
          />
          <div>
            <div className="mb-24">
              <InputText
                HandleChange={e =>
                  handleTravelAgencyClientInputChange(
                    'finalClientFirstName',
                    e.target.value,
                  )
                }
                Id="finalClientFirstName"
                Name="finalClientFirstName"
                Value={
                  editedBookingLocal?.travelAgencyData?.finalClientFirstName ??
                  ''
                }
                IsRequired
                Label={t(
                  'travelAgencyBookingModal:sections:endCustomer:fields.firstName',
                )}
              />
            </div>
            <div className="mb-24">
              <InputText
                HandleChange={e =>
                  handleTravelAgencyClientInputChange(
                    'finalClientLastName',
                    e.target.value,
                  )
                }
                Id="finalClientLastName"
                Name="finalClientLastName"
                Value={
                  editedBookingLocal?.travelAgencyData?.finalClientLastName ??
                  ''
                }
                IsRequired
                Label={t(
                  'travelAgencyBookingModal:sections:endCustomer:fields.lastName',
                )}
              />
            </div>
            <div className="mb-24">
              <InputText
                HandleChange={e =>
                  handleTravelAgencyClientInputChange(
                    'finalClientCompany',
                    e.target.value,
                  )
                }
                Id="company"
                Name="company"
                Value={
                  editedBookingLocal?.travelAgencyData?.finalClientCompany ?? ''
                }
                IsRequired={false}
                Label={t(
                  'travelAgencyBookingModal:sections:endCustomer:fields.company',
                )}
              />
            </div>
            {/* }
            <div className="mb-24">
              <InputText
                HandleChange={e =>
                  handleTravelAgencyClientInputChange(
                    'finalClientStreetAddress',
                    e.target.value,
                  )
                }
                Id="finalClientStreetAddress"
                Name="finalClientStreetAddress"
                Value={
                  editedBookingLocal?.travelAgencyData
                    ?.finalClientStreetAddress ?? ''
                }
                IsRequired
                Label={t(
                  'travelAgencyBookingModal:sections:endCustomer:fields.streetAddress',
                )}
              />
            </div>
            <div className="mb-24">
              <InputText
                HandleChange={e =>
                  handleTravelAgencyClientInputChange(
                    'finalClientZipCode',
                    e.target.value,
                  )
                }
                Id="finalClientZipCode"
                Name="finalClientZipCode"
                Value={
                  editedBookingLocal?.travelAgencyData?.finalClientZipCode ?? ''
                }
                IsRequired
                Label={t(
                  'travelAgencyBookingModal:sections:endCustomer:fields.zipCode',
                )}
              />
            </div>
            <div className="mb-24">
              <InputText
                HandleChange={e =>
                  handleTravelAgencyClientInputChange(
                    'finalClientCity',
                    e.target.value,
                  )
                }
                Id="finalClientCity"
                Name="finalClientCity"
                Value={
                  editedBookingLocal?.travelAgencyData?.finalClientCity ?? ''
                }
                IsRequired
                Label={t(
                  'travelAgencyBookingModal:sections:endCustomer:fields.city',
                )}
              />
            </div>
            { */}
            <div className="mb-24">
              <InputText
                HandleChange={e =>
                  handleTravelAgencyClientInputChange(
                    'finalClientPhone',
                    e.target.value,
                  )
                }
                Id="finalClientPhone"
                Name="finalClientPhone"
                Value={
                  editedBookingLocal?.travelAgencyData?.finalClientPhone ?? ''
                }
                IsRequired
                Label={t(
                  'travelAgencyBookingModal:sections:endCustomer:fields.phone',
                )}
              />
            </div>
            <div className="mb-24">
              <InputText
                HandleChange={e =>
                  handleTravelAgencyClientInputChange(
                    'finalClientEmail',
                    e.target.value,
                  )
                }
                Id="finalClientEmail"
                Name="finalClientEmail"
                Value={
                  editedBookingLocal?.travelAgencyData?.finalClientEmail ?? ''
                }
                IsRequired={false}
                Label={t(
                  'travelAgencyBookingModal:sections:endCustomer:fields.email',
                )}
              />
            </div>
            <div className="mb-24">
              <Select
                inputId="countryId"
                name="countryId"
                placeholder={t(
                  'travelAgencyBookingModal:sections:endCustomer:fields.country',
                )}
                isSearchable
                options={countryOptions}
                classNames={{
                  control: state => 'form-control form-control-react-select',
                }}
                onChange={option =>
                  handleTravelAgencySelectChangeCountry(option)
                }
              />
            </div>
          </div>
        </Col>
        <div>
          {editedBookingLocal !== undefined && editedBookingLocal !== null && (
            <div>
              <Row xs={1} lg={2} className="gx-40 gy-24">
                <Col>
                  {makingOwnerBooking === true && (
                    <div>
                      <Form.Group>
                        <Form.Label>
                          {t(
                            'travelAgencyBookingModal:sections:services.title',
                          )}
                        </Form.Label>
                        <Form.Check
                          label={t(
                            'travelAgencyBookingModal:services.finalCleaning',
                          )}
                          className="mb-8"
                          id="finalcleaning"
                          onChange={() => setCleaningChecked(!cleaningChecked)}
                        />
                        <Form.Check
                          label={t('travelAgencyBookingModal:services.linens')}
                          onChange={() => setLinenChecked(!linenChecked)}
                          id="lining"
                        />
                      </Form.Group>
                      <Form.Group>
                        <h6>
                          {t(
                            'travelAgencyBookingModal:sections:services.selectBookingType',
                          )}
                          :
                        </h6>
                        <Form.Select
                          onChange={e => setOwnerOwnBookingType(e.target.value)}
                          defaultValue="OwnerOwn"
                        >
                          <option value="OwnerOwn">
                            {t(
                              'travelAgencyBookingModal:ownerBookingTypes.ownUse',
                            )}
                          </option>
                          <option value="TemporaryDisabled">
                            {t(
                              'travelAgencyBookingModal:ownerBookingTypes.temporaryDisabled',
                            )}
                          </option>
                          {/* <option value="Maintenance">{t('travelAgencyBookingModal:ownerBookingTypes.maintenance')}</option> */}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  )}
                </Col>
              </Row>
              {makingOwnerBooking === false && (
                <>
                  <hr className="mt-32 mb-24" />
                  <Row className="gx-40 gy-24">
                    <Col lg={8} xl={6}>
                      <div className="d-flex align-items-start">
                        <h5 className="h5 h-md-4 flex-grow-1 me-16 mb-24">
                          {t(
                            'travelAgencyBookingModal:sections:customerInfo.title',
                          )}
                        </h5>
                        <Button
                          variant="primary"
                          onClick={handleAddCustomerBookingNote}
                          disabled={editedCustomerBookingNotes.length > 0}
                          size="sm"
                        >
                          {t(
                            'travelAgencyBookingModal:sections:customerInfo.addComment',
                          )}
                        </Button>
                      </div>
                      {editedCustomerBookingNotes.map((noteItem, noteIndex) => (
                        <div key={noteItem.id}>
                          <Form.Control
                            as="textarea"
                            name={`${noteIndex.toString()}`}
                            value={noteItem.noteText ?? ''}
                            onChange={handleCustomerCommentChange}
                            ref={el => setRef(el, noteIndex)}
                          />
                        </div>
                      ))}
                    </Col>
                  </Row>
                </>
              )}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={() => handleCloseBooking()}>
          {t('common:buttons.close')}
        </Button>
        {editedBookingLocal !== null &&
          editedBookingLocal !== undefined &&
          editedBookingLocal.isAllowedToEdit === true && (
            <Button variant="primary" onClick={() => handleSaveBooking()}>
              {t('common:buttons.save')}
            </Button>
          )}
      </Modal.Footer>
    </Modal>
  );
};
